import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

@Pipe({
  standalone: true,
  name: 'toFormGroup'
})
export class ToFormGroupPipe implements PipeTransform {
  transform(control: AbstractControl): UntypedFormGroup {
    return control as UntypedFormGroup;
  }
}
